import "./choosevacancymodal.scss";
import React from "react";
import { Modal } from "react-bootstrap";
import cross from "images/cross.svg";

import { inject, observer } from "mobx-react";

import OneVacancyCard from "./OneVacancyCard/index";
import { sendMetriks } from "utils/metriks";

const ChooseVacancyModal = ({
  vacancies_for_candidate,
  setModalShowVacancies,
  setSelectedVacancy,
  selectedVacancy,
  setSelectedCandidate,
  selectedCandidate,
  setModalShowCenterDate,
  setSelectedCenter,
  setSelectedDate,
  setUpdateVacancyCandidateId,
  updateCurrentVacancyId,
  updateCurrentVacancyTitle,
  updateCurrentCenterId,
  updateCurrentDate,
  positions,
  cities,
  candidates,
  show,
  onHide
}) => {
  // текущая вакансия отклика уже есть в списке (по id или названию должности) —
  // отдельный пункт "Оставить текущую" не нужен, чтобы не было дубля
  const currentVacancyInList =
    updateCurrentVacancyId &&
    vacancies_for_candidate.some((vacancy) => {
      if (vacancy["id"] === updateCurrentVacancyId) return true;
      const title =
        positions[vacancy["position_id"]] &&
        positions[vacancy["position_id"]]["title"];
      return Boolean(
        title && updateCurrentVacancyTitle && title === updateCurrentVacancyTitle
      );
    });

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Body className="choosevacancy">
        <p>
          <img
            src={cross}
            className="choosevacancy-img"
            onClick={() => {
              setModalShowVacancies(false);
              setSelectedCandidate("");
              setSelectedVacancy("");
              setSelectedCenter("");
              setSelectedDate("");
              setUpdateVacancyCandidateId("");
            }}
            alt=""
          />
        </p>
        <div className="choosevacancy-main">
          <div className="choosevacancy-text">
            <p className="choosevacancy-title">Выберите вакансию</p>
            <p className="choosevacancy-subtitle">Кандидат:</p>
            <span className="choosevacancy-value">
              {candidates.length > 0
                ? candidates.map((candidat) => {
                  if (candidat["id"] === selectedCandidate) {
                    return (
                      <span key={candidat.id}>
                        {candidat["surname"]} {candidat["name"]} {candidat["patronymic"]}
                      </span>
                    );
                  }
                  return null;
                })
                : ""}
            </span>
          </div>
          <div className="choosevacancy-items">
            {/* Обновление отклика: оставить текущую вакансию (если её нет в списке) */}
            {updateCurrentVacancyId && !currentVacancyInList ? (
              <label
                htmlFor="keep-current-vacancy"
                className="choosevacancy-items-checkbox"
              >
                <input
                  type="radio"
                  id="keep-current-vacancy"
                  name="vacancies"
                  checked={selectedVacancy === updateCurrentVacancyId}
                  onChange={() => {
                    setSelectedVacancy(updateCurrentVacancyId);
                    // вернулись к своей вакансии — восстанавливаем прежние УЦ и дату
                    setSelectedCenter(updateCurrentCenterId);
                    setSelectedDate(
                      updateCurrentDate ? new Date(updateCurrentDate) : ""
                    );
                  }}
                />
                <p className="m-0 p-2">
                  Оставить текущую вакансию
                  {updateCurrentVacancyTitle
                    ? ` (${updateCurrentVacancyTitle})`
                    : ""}
                </p>
              </label>
            ) : null}
            {vacancies_for_candidate.length ? (
              <>
                {vacancies_for_candidate.map((vacancy, i) => {
                  if (positions[vacancy["position_id"]])
                    return (
                      <React.Fragment key={vacancy.id}>
                        <label htmlFor={vacancy.id} className="choosevacancy-items-checkbox">
                          <input
                            type="radio"
                            id={vacancy.id}
                            name="vacancies"
                            checked={selectedVacancy === vacancy["id"]}
                            onChange={() => {
                              setSelectedVacancy(vacancy["id"]);
                              // у другой вакансии своё расписание — прежние УЦ и дата не подходят
                              if (vacancy["id"] !== updateCurrentVacancyId) {
                                setSelectedCenter("");
                                setSelectedDate("");
                              }
                            }}
                          />
                          <OneVacancyCard
                            position={positions[vacancy["position_id"]]["title"]}
                            salary={vacancy.wages.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                            // Вознаграждение скрыто в задаче FRONT-843 
                            // agentSalary={vacancy.agent_wages.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                            worklocation={cities[vacancy.city_id]["title"]}
                            id={vacancy.id}
                            key={vacancy.id}
                            itemnumber={i}
                          />
                        </label>

                        <div
                          key={`small${vacancy.id}`}
                          htmlFor={vacancy.id}
                          className="choosevacancy-items-smallcheckbox"
                          onClick={() => {
                            setSelectedVacancy(vacancy["id"]);
                            if (vacancy["id"] !== updateCurrentVacancyId) {
                              setSelectedCenter("");
                              setSelectedDate("");
                            }
                          }}
                        >
                          <OneVacancyCard
                            position={positions[vacancy["position_id"]]["title"]}
                            salary={vacancy.wages.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                            // Вознаграждение скрыто в задаче FRONT-843 
                            // agentSalary={vacancy.agent_wages.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                            worklocation={cities[vacancy.city_id]["title"]}
                            id={vacancy.id}
                            key={vacancy.id}
                            itemnumber={i}
                          />
                        </div>
                      </React.Fragment>
                    );
                  return null;
                })}
              </>
            ) : (
              <>
                <p>Других доступных вакансий для этого кандидата нет</p>
              </>
            )}
          </div>

          <button
            onClick={() => {
              setModalShowVacancies(false);
              setModalShowCenterDate(true);
              sendMetriks("reachGoal", "resp_3");
            }}
            className="card-candidate-mainbtn"
            disabled={!selectedVacancy}
          >
            Выбрать
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, vacanciesStore, candidatesStore, modalWindows }) => {
  const {
    vacancies,
    allvacancies,
    positions,
    cities,
    statuses,
    getVacanciesData,
    getVacancies_for_candidate,
    vacancies_for_candidate,
    error,
    isLoading,
  } = vacanciesStore;

  const {
    approvePhoneCode,
    approvedPhone,

    checkPhoneCode,
    cleanErrorRegistration,
    errorCode,
  } = usersStore;
  const {
    education_centers,
    candidates,
    applicationsForCandidate,
    setSelectedVacancy,
    selectedVacancy,
    setSelectedCandidate,
    selectedCandidate,
    setSelectedCenter,
    setSelectedDate,
    setUpdateVacancyCandidateId,
    updateCurrentVacancyId,
    updateCurrentVacancyTitle,
    updateCurrentCenterId,
    updateCurrentDate,
    applications,
  } = candidatesStore;

  const { setModalShowVacancies, setModalShowCenterDate } = modalWindows;
  return {
    getVacancies_for_candidate,
    vacancies_for_candidate,

    checkPhoneCode,
    cleanErrorRegistration,
    approvedPhone,
    approvePhoneCode,
    vacancies,
    allvacancies,
    getVacanciesData,
    positions,
    cities,
    statuses,
    education_centers,
    candidates,
    applicationsForCandidate,
    applications,
    setSelectedVacancy,
    selectedVacancy,
    setSelectedCandidate,
    selectedCandidate,
    setSelectedCenter,
    setSelectedDate,
    setUpdateVacancyCandidateId,
    updateCurrentVacancyId,
    updateCurrentVacancyTitle,
    updateCurrentCenterId,
    updateCurrentDate,
    errorCode,
    error,
    isLoading,

    setModalShowVacancies,
    setModalShowCenterDate,
  };
})(observer(ChooseVacancyModal));
